<template>
    <el-card shadow="never" class="aui-card--fill">
        <el-row style="background-color: #F3F4F4;">
            <el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
                <img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/wofangxinxi-icon.png" />开票信息</el-col>
            <el-col :xs="24" :md="18">
                <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
                    
                     <!-- <el-form-item v-if="$hasPermission('plat:platticketinfo:save') && dataList.length < 1 && role != 'OPERATE'">
						<el-button class="addBtn" type="primary" @click="handleEdit()">{{ $t('add') }}</el-button>
                    </el-form-item>
                    <el-form-item v-if="$hasPermission('plat:platticketinfo:delete') && role != 'OPERATE'">
						<el-button class="delBtn" type="danger"  @click="handleDele()">{{ $t("deleteBatch") }}</el-button>
                    </el-form-item> -->
                    <el-form-item v-if="role != 'COMPANY'">
                        <el-button class="refreshBtn" type="default" @click="getDataList()">刷新</el-button>
                    </el-form-item>
                    <el-form-item v-if="role == 'COMPANY'">
                        <el-button class="refreshBtn" type="primary" @click="$refs.kpEdit.dataFormSubmitHandle()">保存</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <div class="mod-plat__platticketpro table-full-height" v-if="role != 'COMPANY'">
            <!-- <el-form :inline="true" ref="searchForm" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item label="公司名称" style="margin-top: 20px;margin-left: 20px;">
                    <el-input v-model="dataForm.caName" placeholder="输入公司名称查询" clearable></el-input>
                </el-form-item>
                <el-form-item style="margin-top: 20px;margin-left: 20px;">
                    <el-button type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
                </el-form-item>
                <el-form-item style="margin-top: 20px;margin-left: 20px;">
                    <el-button type="refreshBtn" @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form> -->
            <el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" style="width: 100%;" height="100%">
                <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
                <el-table-column label="序号" type="index" width="50" align="center">
                    <template slot-scope="scope">
                        <span>{{(page - 1) * limit + scope.$index + 1}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="caName" label="企业名称" header-align="center" align="center"></el-table-column>
				<!-- <el-table-column prop="abbreviation" label="税源地简称" header-align="center" align="center"></el-table-column> -->
                <el-table-column prop="ratepayerCode" label="购买方纳税人识别号" header-align="center" align="center"></el-table-column>
                <el-table-column prop="bankName" label="开户行名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="bankAccount" label="开户账号" header-align="center" align="center"></el-table-column>
                <el-table-column prop="phone" label="注册电话" header-align="center" align="center"></el-table-column>
                <el-table-column prop="address" label="注册地址" header-align="center" align="center"></el-table-column>
                <el-table-column prop="pickName" label="收票人姓名" header-align="center" align="center"></el-table-column>
                <el-table-column prop="mobile" label="收票人电话" header-align="center" align="center"></el-table-column>
                <el-table-column prop="pickAddress" label="收票人地址" header-align="center" align="center"></el-table-column>
                <el-table-column prop="email" label="电子邮箱" header-align="center" align="center"></el-table-column>
                <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="200" v-if="role != 'OPERATE'">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleEdit(scope.row)">{{ $t('update') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                :current-page="page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="limit"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="pageSizeChangeHandle"
                @current-change="pageCurrentChangeHandle">
            </el-pagination>
        </div>
        
         <!-- 弹窗, 新增 / 修改 -->
        <kpEdit v-else ref="kpEdit"></kpEdit>
    </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import kpEdit from './kp-edit.vue'
import Cookies from 'js-cookie'
export default {
    name: "platTicketInfo",
    mixins: [mixinViewModule],
    components:{kpEdit},
    data () {
        return {
            role: Cookies.get('admin_role'),
            listDetail:{
                caName:this.$store.state.user.name,
                ratepayerCode:localStorage.getItem('homeUserInfoId'),
                bankName:'',
                bankAccount:'',
                address:'',
                phone:'',
            },
            grUpdateVisible:false,
            dataListSelections:[],
            mixinViewModuleOptions: {},
            dataForm: {
                // userId: this.$store.state.user.id
            }
        }
    },
    created(){
        if(this.role == 'COMPANY'){

        }else{
            this.mixinViewModuleOptions = {
                getDataListURL: '/sys/plat/ticketInfo/page',
                getDataListIsPage: true,
                deleteIsBatch: true,
                deleteURL: "/sys/plat/ticketInfo/delete",
                // exportURL: '/sys/companyStaff/export'
            }
            this.getDataList();
        }
    },
    methods: {
        handleEdit(row){
            this.grUpdateVisible = true
            if(row){
                this.listDetail = row;
                this.$nextTick(() => {
                    this.$refs.kpEdit.isAdd = false;
                    this.$refs.kpEdit.init()
                })
            }else{
                this.listDetail = {
                    caName:this.$store.state.user.caName,
                    ratepayerCode:localStorage.getItem('homeUserInfoId'),
                    bankName:'',
                    bankAccount:'',
                    address:'',
                    phone:'',
                }
                this.$nextTick(() => {
                    this.$refs.kpEdit.isAdd = true;
                    this.$refs.kpEdit.init()
                })
            }
        },
        // 多选
        dataListSelectionChangeHandle (val) {
            this.dataListSelections = val
            this.dataListSelectionid = val.map((item) => {
                return item.id;
            })
        },
        handleDele(){
            console.log(this.dataListSelections.map(item => item['id']))
            if (this.dataListSelections.length <= 0) {
                return this.$message({
                message: this.$t('prompt.deleteBatch'),
                type: 'warning',
                duration: 500
                })
            }
            this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
                confirmButtonText: this.$t('confirm'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning'
            }).then(() => {
                this.$http.post('/sys/plat/ticketInfo/delete',this.dataListSelections.map(item => item['id'])).then(({ data: res }) => {
                if (res.code !== 0) {
                    return this.$message.error(res.msg)
                }
                this.$message({
                    message: this.$t('prompt.success'),
                    type: 'success',
                    duration: 500,
                    onClose: () => {
                    this.query()
                    }
                })
                }).catch(() => {})
            }).catch(() => {})
        },
        handleReset(){
            this.dataForm.caName = "";
            this.getDataList()
        }
    }
}
</script>



<style scoped>
.table-full-height {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 190px); /* 120px可根据实际头部高度调整 */
}
.table-full-height .el-table {
    flex: 1 1 auto;
    min-height: 0;
}
.el-pagination {
    position: sticky;
    bottom: 0;
    z-index: 2;
    background: #fff;
}

</style>
